import styled from 'styled-components';
import media from "styled-query";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 3rem;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--gray);
  width: 100%;
  margin-top: 1rem;
`;

export const Content = styled.div`
  width: 1120px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 3rem 0;

  ${media.lessThan("1200px")`
    margin: 24px;
    width: 100%;
  `}

  ${media.lessThan("1023px")`
    margin: 24px;
    flex-direction: column;
    text-align: center;
  `}
`;

export const Items = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--gray);
`;
